import React, { useState } from 'react';
import './UomForm.css';
import '../../../shared/StyledInput.css';
import RequiredMark from '../../../shared/RequiredMark';
import CancelButton from '../../../shared/CancelButton';
import SaveButton from '../../../shared/SaveButton';
import NumberInput from '../../../shared/NumberInput';

function UomForm({ initial, onSave, onCancel, loading }) {
  const [code, setCode] = useState(initial?.code || '');
  const [name, setName] = useState(initial?.name || '');
  const [plural_name, setPluralName] = useState(initial?.plural_name || '');
  const [description, setDescription] = useState(initial?.description || '');
  const [default_conversion_rate, setDefaultConversionRate] = useState(initial?.default_conversion_rate ?? '');
  const [error, setError] = useState('');

  const validate = () => {
    if (!code.trim()) return 'Code is required.';
    if (!name.trim()) return 'Name is required.';
    if (default_conversion_rate !== '' && (!Number.isInteger(Number(default_conversion_rate)) || Number(default_conversion_rate) < 1)) {
      return 'Default Conversion Rate must be a positive whole number.';
    }
    return '';
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setError(err);
    setError('');
    onSave({
      code: code.trim().toUpperCase(),
      name: name.trim(),
      plural_name: plural_name.trim(),
      description: description.trim(),
      default_conversion_rate: default_conversion_rate === '' ? '' : Number(default_conversion_rate),
    });
  };

  return (
    <form className="uom-form" onSubmit={handleSubmit} style={{ minWidth: 320 }}>
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
        <div>
          <label>Code<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            maxLength={10}
            placeholder="e.g., PCS"
            style={{ width: 100 }}
          />
        </div>
        <div>
          <label>Name<RequiredMark /></label><br />
          <input
            className="styled-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={100}
            placeholder="e.g., Pieces"
          />
        </div>
        <div>
          <label>Plural Name</label><br />
          <input
            className="styled-input"
            value={plural_name}
            onChange={(e) => setPluralName(e.target.value)}
            maxLength={100}
            placeholder="e.g., Pieces"
          />
        </div>
        <div>
          <label>Default Conversion Rate</label><br />
          <NumberInput
            decimals={0}
            min="1"
            step="1"
            value={default_conversion_rate}
            onChange={(e) => setDefaultConversionRate(e.target.value)}
            placeholder="e.g., 100"
            style={{ width: 100 }}
          />
        </div>
      </div>

      <div style={{ marginTop: 14 }}>
        <label>Description</label><br />
        <textarea
          className="styled-input"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={2}
          style={{ width: '100%', maxWidth: 480, resize: 'vertical' }}
          placeholder="Optional notes on what this unit represents and when to use it"
        />
      </div>

      {error && <div style={{ color: 'red', marginTop: 8 }}>{error}</div>}

      <div style={{ marginTop: 12 }}>
        <SaveButton loading={loading} />
        <CancelButton onClick={onCancel} disabled={loading} style={{ marginLeft: 8 }} />
      </div>
    </form>
  );
}

export default UomForm;
